import React from "react";
import {Dropdown} from "react-bootstrap";
import {BsChevronDown} from "react-icons/bs";
import './StyledSelect.css';

const StyledSelect = ({value, options, placeholder, onChange, disabled}) => {
    const selectedOption = options.find(o => o.value === value);

    return (
        <Dropdown>
            <Dropdown.Toggle
                as="div"
                bsPrefix="styled-select"
                className={`styled-select-toggle ${disabled ? 'disabled' : ''}`}
            >
                <span className={selectedOption ? 'styled-select-value' : 'styled-select-placeholder'}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <BsChevronDown className="styled-select-chevron"/>
            </Dropdown.Toggle>
            {!disabled && (
                <Dropdown.Menu className="styled-select-menu">
                    {options.map(o => (
                        <Dropdown.Item
                            key={o.value}
                            active={o.value === value}
                            onClick={() => onChange(o.value)}
                        >
                            {o.label}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            )}
        </Dropdown>
    );
};

export default StyledSelect;
